var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 4,
    fill: "#73777A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loading_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4a2.25 2.25 0 1 1-1.555-2.14",
    stroke: "#fff",
    strokeWidth: 0.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loading_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h6v6H0z"
  })))));
};
export default SvgLoading;